module.exports = __webpack_public_path__ + "static/media/image3.7c620ec4.jpg";